"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.E2ValueHomeQualityEnum = exports.E2ValueBasementTypeEnum = exports.E2ValueRoofShapeTypeEnum = exports.E2ValueHeatingTypeEnum = exports.E2ValueExteriorWallTypeEnum = exports.E2ValueRoofCoveringTypeEnum = exports.E2ValueHomeStyleStructureTypeEnum = exports.E2ValueGarageCapacityEnum = exports.E2ValueGarageTypeEnum = exports.E2ValueConstructionTypeEnum = exports.E2ValueFoundationTypeEnum = void 0;
var E2ValueFoundationTypeEnum;
(function (E2ValueFoundationTypeEnum) {
    E2ValueFoundationTypeEnum["brick"] = "brick";
    E2ValueFoundationTypeEnum["concreteBlock"] = "concrete block";
    E2ValueFoundationTypeEnum["concreteSlab"] = "concrete slab";
    E2ValueFoundationTypeEnum["fieldstone"] = "fieldstone";
    E2ValueFoundationTypeEnum["hollandClayTile"] = "holland clay tile";
    E2ValueFoundationTypeEnum["noPermanentFoundation"] = "no permanent foundation";
    E2ValueFoundationTypeEnum["pier"] = "pier";
    E2ValueFoundationTypeEnum["pierBeam"] = "pier and beam";
    E2ValueFoundationTypeEnum["pilings"] = "pilings";
    E2ValueFoundationTypeEnum["pouredConcrete"] = "poured concrete";
    E2ValueFoundationTypeEnum["stone"] = "stone";
    E2ValueFoundationTypeEnum["stoneRubbleMortar"] = "stone rubble and mortar";
    E2ValueFoundationTypeEnum["treatedWood"] = "treated wood";
})(E2ValueFoundationTypeEnum || (exports.E2ValueFoundationTypeEnum = E2ValueFoundationTypeEnum = {}));
var E2ValueConstructionTypeEnum;
(function (E2ValueConstructionTypeEnum) {
    E2ValueConstructionTypeEnum["aFrame"] = "A - frame";
    E2ValueConstructionTypeEnum["autoclavedAeratedConcrete"] = "autoclaved aerated concrete";
    E2ValueConstructionTypeEnum["foamFormConcrete"] = "foam form concrete";
    E2ValueConstructionTypeEnum["steelFrame"] = "framing, steel";
    E2ValueConstructionTypeEnum["woodFrame"] = "framing, wood";
    E2ValueConstructionTypeEnum["elevatedWoodSlabFrame"] = "framing, wood with elevated slab";
    E2ValueConstructionTypeEnum["log"] = "log";
    E2ValueConstructionTypeEnum["blockMasonry"] = "masonry, block";
    E2ValueConstructionTypeEnum["brickMasonry"] = "masonry, brick";
    E2ValueConstructionTypeEnum["stoneMasonry"] = "masonry, stone";
    E2ValueConstructionTypeEnum["modularWoodFrame"] = "modular, wood frame";
    E2ValueConstructionTypeEnum["poleFrame"] = "pole frame";
    E2ValueConstructionTypeEnum["pouredConcrete"] = "poured concrete";
    E2ValueConstructionTypeEnum["rammedEarth"] = "rammed earth";
    E2ValueConstructionTypeEnum["rigidMetalFrame"] = "rigid metal frame";
    E2ValueConstructionTypeEnum["soilCement"] = "soil cement";
    E2ValueConstructionTypeEnum["stick"] = "stick";
    E2ValueConstructionTypeEnum["strawbale"] = "strawbale";
    E2ValueConstructionTypeEnum["structuralInsulatedPanel"] = "structural insulated panel";
    E2ValueConstructionTypeEnum["stuccoFrame"] = "stucco on frame";
    E2ValueConstructionTypeEnum["stuccoMasonry"] = "stucco on masonry";
    E2ValueConstructionTypeEnum["timberPostBeam"] = "timber/post & beam";
    E2ValueConstructionTypeEnum["brickVeneer"] = "veneer, brick";
    E2ValueConstructionTypeEnum["brickVeneerOnWoodFrame"] = "veneer, brick with wood frame";
    E2ValueConstructionTypeEnum["stoneVeneer"] = "veneer, stone";
})(E2ValueConstructionTypeEnum || (exports.E2ValueConstructionTypeEnum = E2ValueConstructionTypeEnum = {}));
var E2ValueGarageTypeEnum;
(function (E2ValueGarageTypeEnum) {
    E2ValueGarageTypeEnum["garageAttached"] = "Garage, Attached";
    E2ValueGarageTypeEnum["garageBasement"] = "Garage, Basement";
    E2ValueGarageTypeEnum["garageBasementBreakawayWalls"] = "Garage, Basement W/breakaway Walls";
    E2ValueGarageTypeEnum["garageBuiltIn"] = "Garage, Built-in";
    E2ValueGarageTypeEnum["garageFinishedAttached"] = "Garage, Finished Attached";
    E2ValueGarageTypeEnum["garageFinishedBasement"] = "Garage, Finished Basement";
    E2ValueGarageTypeEnum["garageFinishedBuiltIn"] = "Garage, Finished Built-In";
})(E2ValueGarageTypeEnum || (exports.E2ValueGarageTypeEnum = E2ValueGarageTypeEnum = {}));
var E2ValueGarageCapacityEnum;
(function (E2ValueGarageCapacityEnum) {
    E2ValueGarageCapacityEnum[E2ValueGarageCapacityEnum["one"] = 1] = "one";
    E2ValueGarageCapacityEnum[E2ValueGarageCapacityEnum["two"] = 2] = "two";
    E2ValueGarageCapacityEnum[E2ValueGarageCapacityEnum["three"] = 3] = "three";
    E2ValueGarageCapacityEnum[E2ValueGarageCapacityEnum["four"] = 4] = "four";
})(E2ValueGarageCapacityEnum || (exports.E2ValueGarageCapacityEnum = E2ValueGarageCapacityEnum = {}));
var E2ValueHomeStyleStructureTypeEnum;
(function (E2ValueHomeStyleStructureTypeEnum) {
    E2ValueHomeStyleStructureTypeEnum["twoFamilyHome"] = "2 - Family Home";
    E2ValueHomeStyleStructureTypeEnum["threeFamilyHome"] = "3 - Family Home";
    E2ValueHomeStyleStructureTypeEnum["fourFamilyHome"] = "4 - Family Home";
    E2ValueHomeStyleStructureTypeEnum["aFrame"] = "A - Frame";
    E2ValueHomeStyleStructureTypeEnum["adams"] = "Adams";
    E2ValueHomeStyleStructureTypeEnum["adirondack"] = "Adirondack";
    E2ValueHomeStyleStructureTypeEnum["adobe"] = "Adobe";
    E2ValueHomeStyleStructureTypeEnum["americanFourSquare"] = "American Four Square";
    E2ValueHomeStyleStructureTypeEnum["architecturallyUnique"] = "Architecturally Unique";
    E2ValueHomeStyleStructureTypeEnum["artDeco"] = "Art Deco";
    E2ValueHomeStyleStructureTypeEnum["artModerne"] = "Art Moderne";
    E2ValueHomeStyleStructureTypeEnum["artsAndCraftsStyle"] = "Arts and Crafts Style";
    E2ValueHomeStyleStructureTypeEnum["basic"] = "Basic";
    E2ValueHomeStyleStructureTypeEnum["bayRegion"] = "Bay Region";
    E2ValueHomeStyleStructureTypeEnum["beauxArts"] = "Beaux Arts";
    E2ValueHomeStyleStructureTypeEnum["biLevel"] = "Bi - level";
    E2ValueHomeStyleStructureTypeEnum["brownstone"] = "Brownstone";
    E2ValueHomeStyleStructureTypeEnum["brownstoneEndUnit"] = "Brownstone - End Unit";
    E2ValueHomeStyleStructureTypeEnum["brownstoneBowfrontVictorian"] = "Brownstone, Bowfront Victorian";
    E2ValueHomeStyleStructureTypeEnum["brownstoneBowfrontVictorianEndUnit"] = "Brownstone, Bowfront Victorian - End Unit";
    E2ValueHomeStyleStructureTypeEnum["brownstoneStandAlone"] = "Brownstone, Stand Alone";
    E2ValueHomeStyleStructureTypeEnum["brownstoneVictorian"] = "Brownstone, Victorian";
    E2ValueHomeStyleStructureTypeEnum["brownstoneVictorianEndUnit"] = "Brownstone, Victorian - End Unit";
    E2ValueHomeStyleStructureTypeEnum["bungalow"] = "Bungalow";
    E2ValueHomeStyleStructureTypeEnum["californiaRanch"] = "California Ranch";
    E2ValueHomeStyleStructureTypeEnum["capeCod"] = "Cape Cod";
    E2ValueHomeStyleStructureTypeEnum["carpenterGothic"] = "Carpenter Gothic";
    E2ValueHomeStyleStructureTypeEnum["castleLike"] = "Castle-Like";
    E2ValueHomeStyleStructureTypeEnum["chalet"] = "chalet";
    E2ValueHomeStyleStructureTypeEnum["charleston"] = "Charleston";
    E2ValueHomeStyleStructureTypeEnum["chateau"] = "Chateau";
    E2ValueHomeStyleStructureTypeEnum["cityHouse"] = "City House";
    E2ValueHomeStyleStructureTypeEnum["cityHouseEndUnit"] = "City House - End Unit";
    E2ValueHomeStyleStructureTypeEnum["cityHouseArtDeco"] = "City House, Art Deco";
    E2ValueHomeStyleStructureTypeEnum["cityHouseArtDecoEndUnit"] = "City House, Art Deco - End Unit";
    E2ValueHomeStyleStructureTypeEnum["cityHouseArtModerne"] = "City House, Art Moderne";
    E2ValueHomeStyleStructureTypeEnum["cityHouseArtModerneEndUnit"] = "City House, Art Moderne - End Unit";
    E2ValueHomeStyleStructureTypeEnum["cityHouseBeauxArtsClassical"] = "City House, Beaux Arts Classical";
    E2ValueHomeStyleStructureTypeEnum["cityHouseBeauxArtsClassicalEndUnit"] = "City House, Beaux Arts Classical - End Unit";
    E2ValueHomeStyleStructureTypeEnum["cityHouseGothic"] = "City House, Gothic";
    E2ValueHomeStyleStructureTypeEnum["cityHouseGothicEndUnit"] = "City House, Gothic - End Unit";
    E2ValueHomeStyleStructureTypeEnum["cityHouseInternationalStyle"] = "City House, International Style";
    E2ValueHomeStyleStructureTypeEnum["cityHouseInternationalStyleEndUnit"] = "City House, International Style - End Unit";
    E2ValueHomeStyleStructureTypeEnum["cityHouseItalianate"] = "City House, Italianate";
    E2ValueHomeStyleStructureTypeEnum["cityHouseItalianateEndUnit"] = "City House, Italianate - End Unit";
    E2ValueHomeStyleStructureTypeEnum["cityHouseNeoClassical"] = "City House, Neo-Classical";
    E2ValueHomeStyleStructureTypeEnum["cityHouseNeoClassicalEndUnit"] = "City House, Neo-Classical - End Unit";
    E2ValueHomeStyleStructureTypeEnum["cityHouseRenaissance"] = "City House, Renaissance";
    E2ValueHomeStyleStructureTypeEnum["cityHouseRenaissanceEndUnit"] = "City House, Renaissance - End Unit";
    E2ValueHomeStyleStructureTypeEnum["cityHouseRenaissanceRevival"] = "City House, Renaissance Revival";
    E2ValueHomeStyleStructureTypeEnum["cityHouseRenaissanceRevivalEndUnit"] = "City House, Renaissance Revival - End Unit";
    E2ValueHomeStyleStructureTypeEnum["cityHouseRomanesque"] = "City House, Romanesque";
    E2ValueHomeStyleStructureTypeEnum["cityHouseRomanesqueEndUnit"] = "City House, Romanesque - End Unit";
    E2ValueHomeStyleStructureTypeEnum["cityHouseSecondEmpire"] = "City House, Second Empire";
    E2ValueHomeStyleStructureTypeEnum["cityHouseSecondEmpireEndUnit"] = "City House, Second Empire - End Unit";
    E2ValueHomeStyleStructureTypeEnum["cityHouseSullivanesque"] = "City House, Sullivanesque";
    E2ValueHomeStyleStructureTypeEnum["cityHouseSullivanesqueEndUnit"] = "City House, Sullivanesque - End Unit";
    E2ValueHomeStyleStructureTypeEnum["classicalRevival"] = "Classical Revival";
    E2ValueHomeStyleStructureTypeEnum["coop"] = "Co-Op";
    E2ValueHomeStyleStructureTypeEnum["colonial"] = "Colonial";
    E2ValueHomeStyleStructureTypeEnum["colonialCustom"] = "Colonial, Custom";
    E2ValueHomeStyleStructureTypeEnum["colonialDutch"] = "Colonial, Dutch";
    E2ValueHomeStyleStructureTypeEnum["colonialEarlyAmerican"] = "Colonial, Early American";
    E2ValueHomeStyleStructureTypeEnum["colonialEclectic"] = "Colonial, Eclectic";
    E2ValueHomeStyleStructureTypeEnum["colonialFrench"] = "Colonial, French";
    E2ValueHomeStyleStructureTypeEnum["colonialGerman"] = "Colonial, German";
    E2ValueHomeStyleStructureTypeEnum["colonialManor"] = "Colonial, Manor";
    E2ValueHomeStyleStructureTypeEnum["colonialNewEngland"] = "Colonial, New England Style";
    E2ValueHomeStyleStructureTypeEnum["colonialPlantation"] = "Colonial, Plantation";
    E2ValueHomeStyleStructureTypeEnum["colonialRevival"] = "Colonial, Revival";
    E2ValueHomeStyleStructureTypeEnum["colonialRevivalEclectic"] = "Colonial, Revival Eclectic";
    E2ValueHomeStyleStructureTypeEnum["colonialSouthern"] = "Colonial, Southern";
    E2ValueHomeStyleStructureTypeEnum["colonialSpanish"] = "Colonial, Spanish";
    E2ValueHomeStyleStructureTypeEnum["colonialTract"] = "Colonial, Tract";
    E2ValueHomeStyleStructureTypeEnum["completelyCustom"] = "Completely Custom";
    E2ValueHomeStyleStructureTypeEnum["conch"] = "Conch";
    E2ValueHomeStyleStructureTypeEnum["condo"] = "Condo";
    E2ValueHomeStyleStructureTypeEnum["contemporary"] = "Contemporary";
    E2ValueHomeStyleStructureTypeEnum["contemporaryCalifornia"] = "Contemporary, California";
    E2ValueHomeStyleStructureTypeEnum["contemporaryEnglish"] = "Contemporary, English";
    E2ValueHomeStyleStructureTypeEnum["contemporaryFrench"] = "Contemporary, French";
    E2ValueHomeStyleStructureTypeEnum["contemporaryTudor"] = "Contemporary, Tudor";
    E2ValueHomeStyleStructureTypeEnum["contractorModern"] = "Contractor Modern";
    E2ValueHomeStyleStructureTypeEnum["convertedBarn"] = "Converted Barn";
    E2ValueHomeStyleStructureTypeEnum["cottage"] = "Cottage";
    E2ValueHomeStyleStructureTypeEnum["countryStyle"] = "Country Style";
    E2ValueHomeStyleStructureTypeEnum["craftsmanStyle"] = "Craftsman Style";
    E2ValueHomeStyleStructureTypeEnum["deconstruction"] = "Deconstruction";
    E2ValueHomeStyleStructureTypeEnum["designedByFamousArchitect"] = "Designed by a Famous Architect";
    E2ValueHomeStyleStructureTypeEnum["doublewide"] = "Doublewide";
    E2ValueHomeStyleStructureTypeEnum["duplex"] = "Duplex";
    E2ValueHomeStyleStructureTypeEnum["earthShelterBermed"] = "Earth Shelter, Bermed";
    E2ValueHomeStyleStructureTypeEnum["earthShelterHillside"] = "Earth Shelter, Hillside";
    E2ValueHomeStyleStructureTypeEnum["earthShelterUnderground"] = "Earth Shelter, Underground";
    E2ValueHomeStyleStructureTypeEnum["eastlake"] = "Eastlake";
    E2ValueHomeStyleStructureTypeEnum["eclecticFrench"] = "Eclectic, French";
    E2ValueHomeStyleStructureTypeEnum["eclecticNeoclassical"] = "Eclectic, Neoclassical";
    E2ValueHomeStyleStructureTypeEnum["englishStyle"] = "English Style";
    E2ValueHomeStyleStructureTypeEnum["europeanInfluenced"] = "European Influenced";
    E2ValueHomeStyleStructureTypeEnum["farmhouse"] = "Farmhouse";
    E2ValueHomeStyleStructureTypeEnum["federal"] = "Federal";
    E2ValueHomeStyleStructureTypeEnum["fourplex"] = "Fourplex";
    E2ValueHomeStyleStructureTypeEnum["frenchProvincialAlsoFrenchRevival"] = "French Provincial (also French Revival)";
    E2ValueHomeStyleStructureTypeEnum["frenchStyle"] = "French Style";
    E2ValueHomeStyleStructureTypeEnum["geodesicDome"] = "Geodesic Dome";
    E2ValueHomeStyleStructureTypeEnum["georgian"] = "Georgian";
    E2ValueHomeStyleStructureTypeEnum["georgianRevival"] = "Georgian Revival";
    E2ValueHomeStyleStructureTypeEnum["germanStone"] = "German Stone";
    E2ValueHomeStyleStructureTypeEnum["gingerbread"] = "Gingerbread";
    E2ValueHomeStyleStructureTypeEnum["gothicRevival"] = "Gothic Revival";
    E2ValueHomeStyleStructureTypeEnum["greekRevival"] = "Greek Revival";
    E2ValueHomeStyleStructureTypeEnum["golfCoastStyle"] = "Gulf Coast Style";
    E2ValueHomeStyleStructureTypeEnum["highRanch"] = "High Ranch";
    E2ValueHomeStyleStructureTypeEnum["internationalStyle"] = "International Style";
    E2ValueHomeStyleStructureTypeEnum["italianVilla"] = "Italian Villa";
    E2ValueHomeStyleStructureTypeEnum["italianate"] = "Italianate";
    E2ValueHomeStyleStructureTypeEnum["katrinaCottage"] = "Katrina Cottage";
    E2ValueHomeStyleStructureTypeEnum["keyWestStyle"] = "Key West Style";
    E2ValueHomeStyleStructureTypeEnum["log"] = "Log";
    E2ValueHomeStyleStructureTypeEnum["logKit"] = "Log Kit";
    E2ValueHomeStyleStructureTypeEnum["mansard"] = "Mansard";
    E2ValueHomeStyleStructureTypeEnum["mansion"] = "Mansion";
    E2ValueHomeStyleStructureTypeEnum["mediterranean"] = "Mediterranean";
    E2ValueHomeStyleStructureTypeEnum["missionStyle"] = "Mission Style";
    E2ValueHomeStyleStructureTypeEnum["moderne"] = "Moderne";
    E2ValueHomeStyleStructureTypeEnum["montereyStyle"] = "Monterey Style";
    E2ValueHomeStyleStructureTypeEnum["neoClassical"] = "Neo-Classical";
    E2ValueHomeStyleStructureTypeEnum["neoColonial"] = "Neo-Colonial";
    E2ValueHomeStyleStructureTypeEnum["neoFrench"] = "Neo-French";
    E2ValueHomeStyleStructureTypeEnum["neoMediterranean"] = "Neo-Mediterranean";
    E2ValueHomeStyleStructureTypeEnum["neoTudor"] = "Neo-Tudor";
    E2ValueHomeStyleStructureTypeEnum["neoVictorian"] = "Neo-Victorian";
    E2ValueHomeStyleStructureTypeEnum["newEnglandColonial"] = "New England Colonial";
    E2ValueHomeStyleStructureTypeEnum["normandyStyle"] = "Normandy Style";
    E2ValueHomeStyleStructureTypeEnum["octagon"] = "Octagon";
    E2ValueHomeStyleStructureTypeEnum["oneOfAKind"] = "One-of-a-Kind";
    E2ValueHomeStyleStructureTypeEnum["palatial"] = "Palatial";
    E2ValueHomeStyleStructureTypeEnum["parkModel"] = "Park Model";
    E2ValueHomeStyleStructureTypeEnum["period"] = "Period";
    E2ValueHomeStyleStructureTypeEnum["postModern"] = "Post Modern";
    E2ValueHomeStyleStructureTypeEnum["prairieStyle"] = "Prairie Style";
    E2ValueHomeStyleStructureTypeEnum["publicBuildingLike"] = "Public Building-Like";
    E2ValueHomeStyleStructureTypeEnum["pueblo"] = "Pueblo";
    E2ValueHomeStyleStructureTypeEnum["queenAnne"] = "Queen Anne";
    E2ValueHomeStyleStructureTypeEnum["quonsetHut"] = "Quonset Hut";
    E2ValueHomeStyleStructureTypeEnum["raisedCape"] = "Raised Cape";
    E2ValueHomeStyleStructureTypeEnum["raisedRanch"] = "Raised Ranch";
    E2ValueHomeStyleStructureTypeEnum["rambler"] = "Rambler";
    E2ValueHomeStyleStructureTypeEnum["rammedEarth"] = "Rammed Earth";
    E2ValueHomeStyleStructureTypeEnum["ranch"] = "Ranch";
    E2ValueHomeStyleStructureTypeEnum["regency"] = "Regency";
    E2ValueHomeStyleStructureTypeEnum["renaissanceRevival"] = "Renaissance Revival";
    E2ValueHomeStyleStructureTypeEnum["richardsonianRomanesque"] = "Richardsonian Romanesque";
    E2ValueHomeStyleStructureTypeEnum["romanesque"] = "Romanesque";
    E2ValueHomeStyleStructureTypeEnum["saltbox"] = "Saltbox";
    E2ValueHomeStyleStructureTypeEnum["santaBarbara"] = "Santa Barbara";
    E2ValueHomeStyleStructureTypeEnum["santaFeStyle"] = "Santa Fe Style";
    E2ValueHomeStyleStructureTypeEnum["secondEmpire"] = "Second Empire";
    E2ValueHomeStyleStructureTypeEnum["shaker"] = "Shaker";
    E2ValueHomeStyleStructureTypeEnum["shingleStyle"] = "Shingle Style";
    E2ValueHomeStyleStructureTypeEnum["shotgunStyle"] = "Shotgun Style";
    E2ValueHomeStyleStructureTypeEnum["singlewide"] = "Singlewide";
    E2ValueHomeStyleStructureTypeEnum["soilCement"] = "Soil Cement";
    E2ValueHomeStyleStructureTypeEnum["southamptonStyle"] = "Southampton Style";
    E2ValueHomeStyleStructureTypeEnum["spanishMission"] = "Spanish Mission";
    E2ValueHomeStyleStructureTypeEnum["spanishRevival"] = "Spanish Revival";
    E2ValueHomeStyleStructureTypeEnum["spanishStyle"] = "Spanish Style";
    E2ValueHomeStyleStructureTypeEnum["splitEntry"] = "Split entry";
    E2ValueHomeStyleStructureTypeEnum["splitLevel"] = "Split level";
    E2ValueHomeStyleStructureTypeEnum["stickEastern"] = "Stick, Eastern";
    E2ValueHomeStyleStructureTypeEnum["stickWestern"] = "Stick, Western";
    E2ValueHomeStyleStructureTypeEnum["strawbale"] = "Strawbale";
    E2ValueHomeStyleStructureTypeEnum["sullivanesque"] = "Sullivanesque";
    E2ValueHomeStyleStructureTypeEnum["townhouse"] = "Townhouse";
    E2ValueHomeStyleStructureTypeEnum["townhouseEndUnit"] = "Townhouse, End Unit";
    E2ValueHomeStyleStructureTypeEnum["townhouseFederal"] = "Townhouse, Federal Style";
    E2ValueHomeStyleStructureTypeEnum["townhouseFederalEndUnit"] = "Townhouse, Federal Style - End Unit";
    E2ValueHomeStyleStructureTypeEnum["townhouseGeorgian"] = "Townhouse, Georgian Style";
    E2ValueHomeStyleStructureTypeEnum["townhouseGeorgianEndUnit"] = "Townhouse, Georgian Style - End Unit";
    E2ValueHomeStyleStructureTypeEnum["townhouseStandalone"] = "Townhouse, Stand Alone";
    E2ValueHomeStyleStructureTypeEnum["tractHome"] = "Tract Home";
    E2ValueHomeStyleStructureTypeEnum["triLevel"] = "Tri - level";
    E2ValueHomeStyleStructureTypeEnum["triplewide"] = "Triplewide";
    E2ValueHomeStyleStructureTypeEnum["triplex"] = "Triplex";
    E2ValueHomeStyleStructureTypeEnum["tudor"] = "Tudor";
    E2ValueHomeStyleStructureTypeEnum["usonian"] = "Usonian";
    E2ValueHomeStyleStructureTypeEnum["victorian"] = "Victorian";
    E2ValueHomeStyleStructureTypeEnum["westernMountain"] = "Western Mountain";
    E2ValueHomeStyleStructureTypeEnum["wrightian"] = "Wrightian";
})(E2ValueHomeStyleStructureTypeEnum || (exports.E2ValueHomeStyleStructureTypeEnum = E2ValueHomeStyleStructureTypeEnum = {}));
var E2ValueRoofCoveringTypeEnum;
(function (E2ValueRoofCoveringTypeEnum) {
    E2ValueRoofCoveringTypeEnum["aluminum"] = "aluminum";
    E2ValueRoofCoveringTypeEnum["architecturalShingle"] = "architectural shingle";
    E2ValueRoofCoveringTypeEnum["asphaltShingle"] = "asphalt shingle";
    E2ValueRoofCoveringTypeEnum["asphaltShinglesWithSolarPanels"] = "asphalt shingle with solar panels";
    E2ValueRoofCoveringTypeEnum["cedarShingleShake"] = "cedar shingle/shake";
    E2ValueRoofCoveringTypeEnum["clayTile"] = "clay tile";
    E2ValueRoofCoveringTypeEnum["compositionBuiltUp"] = "composition, built-up";
    E2ValueRoofCoveringTypeEnum["compositionRoll"] = "composition roll";
    E2ValueRoofCoveringTypeEnum["compositionShingle"] = "composition shingle";
    E2ValueRoofCoveringTypeEnum["concreteTile"] = "concrete tile";
    E2ValueRoofCoveringTypeEnum["dimensionalAsphaltShingle"] = "dimensional asphalt shingle";
    E2ValueRoofCoveringTypeEnum["elastomeric"] = "Elastomeric";
    E2ValueRoofCoveringTypeEnum["fiberglassShingle"] = "fiberglass shingle";
    E2ValueRoofCoveringTypeEnum["metalStandingSeam"] = "metal other than standing seam";
    E2ValueRoofCoveringTypeEnum["metalCorrugated"] = "metal, corrugated";
    E2ValueRoofCoveringTypeEnum["metalRibbed"] = "metal, ribbed";
    E2ValueRoofCoveringTypeEnum["polyurethaneFoam"] = "polyurethane foam";
    E2ValueRoofCoveringTypeEnum["redSlate"] = "red slate";
    E2ValueRoofCoveringTypeEnum["rubber"] = "rubber";
    E2ValueRoofCoveringTypeEnum["slate"] = "slate";
    E2ValueRoofCoveringTypeEnum["slateGraduated"] = "slate, graduated";
    E2ValueRoofCoveringTypeEnum["slatePatterned"] = "slate, patterned";
    E2ValueRoofCoveringTypeEnum["slateSynthetic"] = "slate, synthetic";
    E2ValueRoofCoveringTypeEnum["spanishTile"] = "Spanish tile";
    E2ValueRoofCoveringTypeEnum["standingSeamCopper"] = "standing seam copper";
    E2ValueRoofCoveringTypeEnum["standingSeamMetal"] = "standing seam metal";
    E2ValueRoofCoveringTypeEnum["steel"] = "steel";
    E2ValueRoofCoveringTypeEnum["steelWithSolarPanels"] = "steel with solar panels";
    E2ValueRoofCoveringTypeEnum["tarAndGravel"] = "tar and gravel";
    E2ValueRoofCoveringTypeEnum["tileWithSolarPanels"] = "tile with solar panels";
    E2ValueRoofCoveringTypeEnum["woodShake"] = "wood shake";
    E2ValueRoofCoveringTypeEnum["woodShingle"] = "wood shingle";
})(E2ValueRoofCoveringTypeEnum || (exports.E2ValueRoofCoveringTypeEnum = E2ValueRoofCoveringTypeEnum = {}));
var E2ValueExteriorWallTypeEnum;
(function (E2ValueExteriorWallTypeEnum) {
    E2ValueExteriorWallTypeEnum["adobe"] = "adobe";
    E2ValueExteriorWallTypeEnum["aluminumSiding"] = "aluminum siding";
    E2ValueExteriorWallTypeEnum["asbestosReplacement"] = "asbestos replacement, cement fiber";
    E2ValueExteriorWallTypeEnum["autoclavedConcreteExposed"] = "autoclaved aerated concrete, exposed";
    E2ValueExteriorWallTypeEnum["autoclavedConcretePainted"] = "autoclaved aerated concrete, painted";
    E2ValueExteriorWallTypeEnum["brickMasonry"] = "brick masonry";
    E2ValueExteriorWallTypeEnum["brickBlockBackup"] = "brick w/block backup";
    E2ValueExteriorWallTypeEnum["brownstone"] = "brownstone";
    E2ValueExteriorWallTypeEnum["cementFiber"] = "cement fiber";
    E2ValueExteriorWallTypeEnum["clapboard"] = "clapboard";
    E2ValueExteriorWallTypeEnum["concreteBlock"] = "concrete block";
    E2ValueExteriorWallTypeEnum["concreteBlockPainted"] = "concrete block, painted";
    E2ValueExteriorWallTypeEnum["concreteReinforced"] = "concrete, reinforced";
    E2ValueExteriorWallTypeEnum["drivit"] = "Drivit/EIFS";
    E2ValueExteriorWallTypeEnum["engineeredWoodSiding"] = "engineered wood siding";
    E2ValueExteriorWallTypeEnum["localStone"] = "local stone";
    E2ValueExteriorWallTypeEnum["metalSiding"] = "metal siding";
    E2ValueExteriorWallTypeEnum["logSiding"] = "siding, log";
    E2ValueExteriorWallTypeEnum["logLessThanElevenInches"] = "log (<11\"diameter)";
    E2ValueExteriorWallTypeEnum["solidStone"] = "solid stone";
    E2ValueExteriorWallTypeEnum["steelSiding"] = "steel siding";
    E2ValueExteriorWallTypeEnum["stucco"] = "stucco";
    E2ValueExteriorWallTypeEnum["stuccoMasonry"] = "stucco over masonry";
    E2ValueExteriorWallTypeEnum["stuccoHalfTimber"] = "stucco with half timbering";
    E2ValueExteriorWallTypeEnum["stuccoSlickFinish"] = "stucco, slick finish";
    E2ValueExteriorWallTypeEnum["stuccoSmoothCoat"] = "stucco, smooth coat";
    E2ValueExteriorWallTypeEnum["stuccoTuscanFinish"] = "stucco, Tuscan finish";
    E2ValueExteriorWallTypeEnum["veneerCommonBrick"] = "veneer, common brick";
    E2ValueExteriorWallTypeEnum["veneerFaceBrick"] = "veneer, face brick";
    E2ValueExteriorWallTypeEnum["veneerStone"] = "veneer, stone";
    E2ValueExteriorWallTypeEnum["veneerSyntheticBrick"] = "veneer, synthetic brick";
    E2ValueExteriorWallTypeEnum["veneerSyntheticStone"] = "veneer, synthetic stone";
    E2ValueExteriorWallTypeEnum["vinylSiding"] = "vinyl siding";
    E2ValueExteriorWallTypeEnum["woodshakeShingle"] = "wood shake/shingle";
    E2ValueExteriorWallTypeEnum["woodSiding"] = "wood siding";
})(E2ValueExteriorWallTypeEnum || (exports.E2ValueExteriorWallTypeEnum = E2ValueExteriorWallTypeEnum = {}));
var E2ValueHeatingTypeEnum;
(function (E2ValueHeatingTypeEnum) {
    E2ValueHeatingTypeEnum["electric"] = "ELECTRIC";
    E2ValueHeatingTypeEnum["gas"] = "GAS";
    E2ValueHeatingTypeEnum["liquidPropane"] = "LIQUID PROPANE";
    E2ValueHeatingTypeEnum["naturalGas"] = "NATURAL GAS";
})(E2ValueHeatingTypeEnum || (exports.E2ValueHeatingTypeEnum = E2ValueHeatingTypeEnum = {}));
var E2ValueRoofShapeTypeEnum;
(function (E2ValueRoofShapeTypeEnum) {
    E2ValueRoofShapeTypeEnum["flat"] = "flat";
    E2ValueRoofShapeTypeEnum["gable"] = "gable";
    E2ValueRoofShapeTypeEnum["gableDormers"] = "gable with dormers";
    E2ValueRoofShapeTypeEnum["gambrel"] = "gambrel";
    E2ValueRoofShapeTypeEnum["hip"] = "hip";
    E2ValueRoofShapeTypeEnum["hipGableDormers"] = "hip with gable dormers";
    E2ValueRoofShapeTypeEnum["mansard"] = "mansard";
    E2ValueRoofShapeTypeEnum["multiLevelContemporary"] = "multi-level contemporary";
    E2ValueRoofShapeTypeEnum["saltBox"] = "salt box";
    E2ValueRoofShapeTypeEnum["shed"] = "shed";
})(E2ValueRoofShapeTypeEnum || (exports.E2ValueRoofShapeTypeEnum = E2ValueRoofShapeTypeEnum = {}));
var E2ValueBasementTypeEnum;
(function (E2ValueBasementTypeEnum) {
    E2ValueBasementTypeEnum["concreteSlab"] = "concrete slab";
    E2ValueBasementTypeEnum["finishedBelowGrade"] = "Basement, Finished Below Grade";
    E2ValueBasementTypeEnum["finishedWalkout"] = "Basement, Finished Walk-Out";
    E2ValueBasementTypeEnum["gardenLevel"] = "Basement, Garden Level";
    E2ValueBasementTypeEnum["partiallyFinished"] = "Basement, Partially Finished";
    E2ValueBasementTypeEnum["partiallyFinishedWalkout"] = "Basement, Partially Finished Walk-Out";
    E2ValueBasementTypeEnum["unfinished"] = "Basement, Unfinished";
    E2ValueBasementTypeEnum["unfinishedWBreakawayWalls"] = "Basement, Unfinished w/Breakaway Walls";
    E2ValueBasementTypeEnum["unfinishedWalkout"] = "Basement, Unfinished Walk-Out";
})(E2ValueBasementTypeEnum || (exports.E2ValueBasementTypeEnum = E2ValueBasementTypeEnum = {}));
var E2ValueHomeQualityEnum;
(function (E2ValueHomeQualityEnum) {
    E2ValueHomeQualityEnum["basicEconomic"] = "basic / economic";
    E2ValueHomeQualityEnum["modestFair"] = "modest / fair";
    E2ValueHomeQualityEnum["averageStandard"] = "average / standard";
    E2ValueHomeQualityEnum["aboveAverageUpgraded"] = "above average / upgraded";
    E2ValueHomeQualityEnum["expensiveCustom"] = "expensive / custom";
    E2ValueHomeQualityEnum["veryExpensiveLuxury"] = "very expensive / luxury";
    E2ValueHomeQualityEnum["opulentMuseumQuality"] = "opulent / museum quality";
})(E2ValueHomeQualityEnum || (exports.E2ValueHomeQualityEnum = E2ValueHomeQualityEnum = {}));
